import Vue from "vue";
import store from "./store";
import router from "./router";

/**
 *  Ascii
 *  https://patorjk.com/software/taag/#p=display&h=2&v=3&c=c%2B%2B&w=%20&f=ANSI%20Regular&t=Topic
 */

const coachingEngine = new Vue({
  router,
  store,

  data: function () {
    return {
      iMaxCoachDays: 7,
    };
  },

  computed: {
    isPro() {
      return this.$store.getters.isPro;
    },

    isAlpha() {
      return this.$store.getters.isAlpha;
    },

    getAccount() {
      return this.$store.getters.getAccount;
    },

    getDialFocus() {
      return this.$userEngine.getPref("nourish.onboarding.focus") || "";
    },

    getDialActive() {
      return Object.entries(
        this.$userEngine.getPref("nourish.onboarding.tracks") || {}
      )
        ?.map(([k, a]) => {
          if (a.start) {
            return k;
          }
        })
        ?.filter(Boolean);
    },

    iDaysRemain() {
      let aDates = Object.values(
        this.$userEngine.getPref("nourish.onboarding.tracks") || {}
      )
        ?.map((a) => {
          if (a.start) {
            return new Date(a.start).getTime();
          }
        })
        ?.filter(Boolean)
        .sort((a, b) => (a > b ? 1 : -1));

      // moved to a 7-day detox! - end July 2025
      return 7 - Math.floor((new Date().getTime() - aDates[0]) / 1000 / 86400);
    },

    isInDetox() {
      return this.getOBxDetoxDay() <= this.iMaxCoachDays;
    },

    sDaysRemain() {
      if (this.iDaysRemain <= 1) {
        return "one more day";
      }
      if (this.iDaysRemain == 7) {
        return "one more week";
      }

      return (
        [
          "0",
          "1",
          "two more",
          "three more",
          "four more",
          "five more",
          "six more",
          "the next seven",
          "the next eight",
          "nine",
          "just ten",
        ][this.iDaysRemain] + " days"
      );
    },

    sHabit() {
      switch (this.$userEngine.getPref("nourish.onboarding.media")) {
        case "traditional":
          return "reading your favourite newspaper";
        case "audio":
          return "watching or listening to the news";
        case "newsapp":
          return "opening your favourite news app";
        case "social":
          return "looking at news on social media";
        case "avoid":
        default:
          return "reading the news, wherever it finds you";
      }
    },

    sHabitIsAre() {
      switch (this.$userEngine.getPref("nourish.onboarding.media")) {
        case "traditional":
          return "Newspapers are";
        case "audio":
          return "TV and radio is";
        case "newsapp":
          return "News apps are";
        case "social":
          return "Social media is";
        case "avoid":
        default:
          return "Most news is";
      }
    },

    sHabitFocus() {
      switch (this.$userEngine.getPref("nourish.onboarding.media")) {
        case "traditional":
          return "most newspapers focus";
        case "audio":
          return "TV and radio focuses";
        case "newsapp":
          return "most news apps focus";
        case "social":
          return "social media promotes";
        case "avoid":
        default:
          return "most sources focus";
      }
    },

    sHabitSuckers() {
      switch (this.$userEngine.getPref("nourish.onboarding.media")) {
        case "traditional":
          return "Most newspapers sucker";
        case "audio":
          return "TV and radio suckers";
        case "newsapp":
          return "Most news apps sucker";
        case "social":
          return "Social media suckers";
        case "avoid":
        default:
          return "Most sources sucker";
      }
    },

    getStartedTitle() {
      switch (this.getDialActive.length) {
        case 1:
          return `Your one-week <span class="callout">news detox</span> starts now.`;
        case 2:
          return `The next step in your <span class="callout"> news detox</span>`;
        case 3:
          return `The <span class="callout">final</span> step of your news detox`;
        default:
          return "";
      }
    },

    getStartedAction() {
      switch (this.getDialActive.length) {
        case 1:
          return "Start here…";
        case 2:
          return "Start here…";
        case 3:
          return "Start here…";
        default:
          return "";
      }
    },

    getStartedSynopsis() {
      switch (this.getDialActive.length) {
        case 1:
          return "You're taking your first step with Nourish—great start! Let's lay the foundation for lasting change.";
        case 2:
          return "You're making progress! This next step on your Nourish journey builds on what you've already started.";
        case 3:
          return "You've made it to the final step! Let's wrap up strong and bring everything together with Nourish.";
        default:
          return "";
      }
    },
  },

  methods: {
    finaliseNextFocus() {
      let oMemo = this.$userEngine.getOnboardMemo();
      if (!oMemo.focus) {
        this.error(`finaliseNextFocus - failed: no new focus?`, oMemo);
        return;
      }

      this.notice(
        `Complete Step: ${this.getDialFocus} // nourish.onboarding.tracks.${this.getDialFocus}.done == `,
        new Date().toUTCString()
      );

      // record the other bits
      let sStepRecord = "";
      switch (this.getOBxTotalSteps()) {
        case 1:
          sStepRecord = "inter";
          break;
        case 3:
          sStepRecord = "detox";
          break;
      }

      if (sStepRecord) {
        this.$userEngine.setPref(
          `nourish.onboarding.score.${sStepRecord}.score`,
          oMemo.news_score
        );
        this.$userEngine.setPref(
          `nourish.onboarding.score.${sStepRecord}.level`,
          oMemo.level
        );
      }

      // mark the current focus as "done"
      this.$userEngine.setPref(
        `nourish.onboarding.tracks.${this.getDialFocus}.done`,
        new Date().toUTCString()
      );
      this.notice(
        `Dial Done: nourish.onboarding.tracks.${this.getDialFocus}.done = `,
        new Date().toUTCString()
      );

      // set up the new focus!
      this.$userEngine.setPref(`nourish.onboarding.focus`, oMemo.focus);
      this.$userEngine.setPref(
        `nourish.onboarding.tracks.${oMemo.focus}.start`,
        new Date().toUTCString()
      );

      this.notice(`New focus: ${oMemo.focus}`);
      this.notice(
        `New start: nourish.onboarding.tracks.${oMemo.focus}.start = `,
        new Date().toUTCString()
      );

      // clear the memo...
      window.setTimeout(() => {
        this.$userEngine.clearOnboardMemo();
        // this.$userEngine.reload(); // NB -- this gets in the way of the settings saving?!
      }, 200);
    },

    coachingSeen() {
      this.notice(
        `Complete Onboarding Flow: ${this.getDialFocus} // nourish.onboarding.tracks.${this.getDialFocus}.intro == `,
        new Date().toUTCString()
      );
      this.$userEngine.setPref(
        `nourish.onboarding.tracks.${this.getDialFocus}.intro`,
        new Date().toUTCString()
      );
    },

    getCoachingStack(sSlug) {
      this.notice(`getCoachingStack: ${sSlug}`);
      switch (sSlug) {
        case "coaching:time":
          return {
            structure: [
              {
                type: "coaching",
                slug: "about-time",
              },
              {
                type: "coaching",
                slug: "dial-time",
              },
              {
                type: "coaching",
                slug: "detox",
              },
            ],
          };
        case "coaching:topics":
          return {
            structure: [
              {
                type: "coaching",
                slug: "about-topics",
              },
              {
                type: "coaching",
                slug: "dial-topics",
              },
              {
                type: "coaching",
                slug: "detox",
              },
            ],
          };
        case "coaching:locales":
          return {
            structure: [
              {
                type: "coaching",
                slug: "about-locales",
              },
              {
                type: "coaching",
                slug: "dial-locales",
              },
              {
                type: "coaching",
                slug: "detox",
              },
            ],
          };

        case "coaching:day-1":
          return {
            structure: [
              {
                type: "onboarding",
                slug: "dashboard-intro",
                template: "dashboard-intro",
                dot: true,
              },

              {
                type: "onboarding",
                slug: "dashboard-detox",
                template: "dashboard-detox",
                dot: true,
              },

              {
                type: "onboarding",
                slug: "dashboard-dashboard",
                template: "dashboard-dashboard",
                dot: true,
              },
            ],
          };

        case "coaching:day-2":
          return {
            structure: [
              {
                type: "onboarding",
                slug: "newsle-knowledge",
                template: "newsle-knowledge",
                dot: true,
              },
              {
                type: "onboarding",
                slug: "newsle-emojis",
                template: "newsle-emojis",
                dot: true,
              },
              {
                type: "onboarding",
                slug: "newsle-play",
                template: "newsle-play",
                dot: true,
              },
            ],
          };

        case "coaching:day-3":
          return {
            structure: [
              {
                type: "onboarding",
                slug: "day-3",
                template: "day-3",
                dot: false,
              },

              {
                type: "score",
                slug: "news",
                byline: "A quick check-in",
                title: `How are you feeling now after reading the news?`,
              },

              {
                type: "question",
                slug: "level",
                byline: `And how's your news consumption?`,
                title: `How much news do you see each day?`,
                action: {
                  message: ``,
                },
                questions: [
                  {
                    option: `More than I'd like`,
                    slug: "high-overload",
                    icon: "onboarding-up",
                    icon_height: "14px",
                    class: "red",
                  },
                  {
                    option: `Quite a lot`,
                    slug: "high-deep",
                    icon: "onboarding-focus",
                    icon_height: "19px",
                    class: "green",
                  },
                  {
                    option: `Totally average`,
                    slug: "normal",
                    icon: "onboarding-paper",
                    icon_height: "17px",
                    class: "green",
                  },
                  {
                    option: `Just headlines`,
                    slug: "headlines",
                    icon: "onboarding-deeper",
                    icon_height: "18px",
                    class: "yellow",
                  },
                  {
                    option: `Not much`,
                    slug: "light",
                    icon: "onboarding-find",
                    icon_height: "18px",
                    class: "blue",
                  },
                ],
              },

              {
                type: "onboarding",
                slug: "day-3-ready",
                template: "day-3-ready",
                dot: false,
              },

              {
                type: "question",
                slug: "focus",
                byline: `Let's move on!`,
                title: `What shall we focus on next?`,
                paragraph: `We'll unlock all 3 rings by the end of the detox. For now, choose one that matters most to you.`,
                action: {
                  message: `Spoiler alert: We'll help with all three, but let's start with the one that matters most to you.`,
                },
                questions: [
                  {
                    option: `Time`,
                    byline: `Focus on spending just enough time reading each day.`,
                    slug: "time",
                    dial: true,
                    class: "time",
                  },
                  {
                    option: `Topics`,
                    byline: `Focus on covering a range of different topics.`,
                    slug: "topics",
                    dial: true,
                    class: "topics",
                  },
                  {
                    option: `Countries`,
                    byline: `Focus on reading news from countries around the world.`,
                    slug: "locales",
                    dial: true,
                    class: "locales",
                  },
                ].filter((a) => {
                  return !this.getDialActive.includes(a.slug);
                }),
              },

              {
                type: "finalise",
                slug: "finalise",
                byline: "Great choice!",
                title: `Just a moment`,
                paragraph: `Let's just save those details. This will only take a moment.`,
                dot: false,
              },
            ],
          };

        case "coaching:day-4":
          return {
            structure: [
              {
                type: "onboarding",
                slug: "invite-intro",
                template: "invite-intro",
                dot: true,
              },

              {
                type: "onboarding",
                slug: "invite-unlock",
                template: "invite-unlock",
                dot: true,
              },

              {
                type: "onboarding",
                slug: "invite-profile",
                template: "invite-profile",
                dot: true,
              },
            ],
          };

        case "coaching:day-5":
          return {
            structure: [
              {
                type: "onboarding",
                slug: "more-explore",
                template: "more-explore",
                dot: true,
              },

              {
                type: "onboarding",
                slug: "more-topics",
                template: "more-topics",
                dot: true,
              },

              {
                type: "onboarding",
                slug: "more-ask",
                template: "more-ask",
                dot: true,
              },
            ],
          };

        case "coaching:day-6":
          return {
            structure: [
              {
                type: "onboarding",
                slug: "day-6",
                template: "day-6",
                dot: false,
              },

              {
                type: "score",
                slug: "news",
                byline: "A quick check-in",
                title: `How are you feeling now after reading the news?`,
              },

              {
                type: "question",
                slug: "level",
                byline: `And how's your news consumption?`,
                title: `How much news do you see each day?`,
                action: {
                  message: ``,
                },
                questions: [
                  {
                    option: `More than I'd like`,
                    slug: "high-overload",
                    icon: "onboarding-up",
                    icon_height: "14px",
                    class: "red",
                  },
                  {
                    option: `Quite a lot`,
                    slug: "high-deep",
                    icon: "onboarding-focus",
                    icon_height: "19px",
                    class: "green",
                  },
                  {
                    option: `Totally average`,
                    slug: "normal",
                    icon: "onboarding-paper",
                    icon_height: "17px",
                    class: "green",
                  },
                  {
                    option: `Just headlines`,
                    slug: "headlines",
                    icon: "onboarding-deeper",
                    icon_height: "18px",
                    class: "yellow",
                  },
                  {
                    option: `Not much`,
                    slug: "light",
                    icon: "onboarding-find",
                    icon_height: "18px",
                    class: "blue",
                  },
                ],
              },

              {
                type: "onboarding",
                slug: "day-6-ready",
                template: "day-6-ready",
                dot: false,
              },

              {
                type: "question",
                slug: "focus",
                title: `Time to unlock the final ring`,
                paragraph: `You've already unlocked 2 rings. Choose the final ring to unlock.`,
                questions: [
                  {
                    option: `Time`,
                    byline: `Focus on spending just enough time reading each day.`,
                    slug: "time",
                    dial: true,
                    class: "time",
                  },
                  {
                    option: `Topics`,
                    byline: `Focus on covering a range of different topics.`,
                    slug: "topics",
                    dial: true,
                    class: "topics",
                  },
                  {
                    option: `Countries`,
                    byline: `Focus on reading news from countries around the world.`,
                    slug: "locales",
                    dial: true,
                    class: "locales",
                  },
                ].filter((a) => {
                  return !this.getDialActive.includes(a.slug);
                }),
              },

              {
                type: "finalise",
                slug: "finalise",
                byline: "Great choice!",
                title: `Just a moment`,
                paragraph: `Let's just save those details. This will only take a moment.`,
                dot: false,
              },
            ],
          };

        case "coaching:day-7":
          return {
            structure: [
              {
                type: "onboarding",
                slug: "end-intro",
                template: "end-intro",
                dot: true,
              },

              {
                type: "onboarding",
                slug: "end-pro",
                template: "end-pro",
                dot: true,
              },
            ],
          };

        // case "coaching:day-8":
        //   return {
        //     structure: [
        //       {
        //         type: "onboarding",
        //         slug: "day-7",
        //         template: "day-7",
        //         dot: false,
        //       },
        //     ],
        //   };
      }

      return {};
    },

    /**
     *  NOURISH 2025 - ONBOARDING
     */

    getExtraOnboarding() {
      let iDetoxDay = this.getOBxDetoxDay();
      let bPickAvailable = this.getOBxPickAvailable();

      this.notice(
        `DETOX: Day: ${iDetoxDay} (Pick: ${bPickAvailable}) (${this.getDialActive})`
      );

      if (!this.$userEngine.isLoaded) {
        this.error(`NOT LOADED YET??`);
        return null;
      }

      // console.log(bPickAvailable, this.getOBxPickAvailable());

      /**
       *  We can pick another thing!
       */
      if (bPickAvailable) {
        return [
          {
            slug: "coaching",
            features: [
              {
                name: this.getOBxPickContent(iDetoxDay).title,
                type: "coaching",
                slug: `coaching:day-${iDetoxDay}`,
                // focus: this.getDialFocus,
                focus: this.getOBxPickContent(iDetoxDay).focus,
                dial: this.getOBxPickContent(iDetoxDay).dial,
                icon: this.getOBxPickContent(iDetoxDay).icon,
                confetti: this.getOBxPickContent(iDetoxDay).confetti,
                action: this.getOBxPickContent(iDetoxDay).action,
                locked: false,
                done: false,
                image: null,
                edition: {
                  synopsis: this.getOBxPickContent(iDetoxDay).body,
                },
                stats: {
                  cards: 3,
                  read: 0,
                },
              },
            ],
          },
        ];
      }

      // get the time they finished the ** focus-specific ** intro
      let sIntro = this.$userEngine.getPref(
        `nourish.onboarding.tracks.${this.getDialFocus}.intro`
      );
      let iIntroOffsetMin = Math.floor(
        (Date.now() - Date.parse(sIntro)) / 1000 / 60
      );

      // if they've not seen the intro, keep it off .. (once they've read it... leave it for 10 minutes...)
      if (!sIntro || iIntroOffsetMin < 10) {
        // console.log(
        //   `Intro Card: ${this.getDialFocus} -- sIntro: "${sIntro}", read: `,
        //   sIntro ? 3 : 0
        // );
        return [
          {
            slug: "coaching",
            features: [
              {
                name: this.getStartedTitle,
                action: this.getStartedAction,
                type: "coaching",
                slug: `coaching:${this.getDialFocus}`,
                dial: true,
                focus: this.getDialFocus,
                locked: false,
                done: false,
                image: null,
                edition: {
                  synopsis: this.getStartedSynopsis,
                },
                stats: {
                  cards: 3,
                  read: sIntro ? 3 : 0,
                },
              },
            ],
          },
        ];
      }
    },

    /**
     * FULL ONBOARDING RESET -- FOR DEBUGGGING ONLY!!
     */
    doOBxResetFull(sNewFocus = "time", sNewMedia = "social") {
      // reset done:
      this.$userEngine.setPref(`nourish.onboarding.done`, false);

      // reset rings:
      ["time", "topics", "locales"].forEach((sFocus) => {
        this.$userEngine.setPref(
          `nourish.onboarding.tracks.${sFocus}.start`,
          ""
        );
        this.$userEngine.setPref(
          `nourish.onboarding.tracks.${sFocus}.intro`,
          ""
        );
        this.$userEngine.setPref(
          `nourish.onboarding.tracks.${sFocus}.done`,
          ""
        );
      });

      // reset scores:
      ["onboard", "inter", "detox"].forEach((sFocus) => {
        this.$userEngine.setPref(`nourish.onboarding.score.${sFocus}.score`, 0);
        this.$userEngine.setPref(
          `nourish.onboarding.score.${sFocus}.level`,
          ""
        );
      });

      // fresh setup:
      this.$userEngine.setPref(`nourish.onboarding.focus`, sNewFocus);
      this.$userEngine.setPref(`nourish.onboarding.media`, sNewMedia);
      this.$userEngine.setPref(
        `nourish.onboarding.tracks.${sNewFocus}.start`,
        new Date().toUTCString()
      );

      // fresh notification track: (not permissions, but history of onboarding pushes..)
      this.$userEngine.setPref(`nourish.onboarding.comms.push`, 0);
      this.$userEngine.setPref(`nourish.onboarding.comms.email`, 0);

      // these could be editable but .. doesn't really affect anything (more for stats/research)
      this.$userEngine.setPref(`nourish.onboarding.score.onboard.score`, 5);
      this.$userEngine.setPref(
        `nourish.onboarding.score.onboard.level`,
        "headline"
      );
    },

    doOBxAdvanceDays(iDays = 1) {
      // push all the dates:
      ["time", "topics", "locales"].forEach((sFocus) => {
        ["start", "intro", "done"].forEach((sDateKey) => {
          let sDate = this.$userEngine.getPref(
            `nourish.onboarding.tracks.${sFocus}.${sDateKey}`
          );
          if (sDate) {
            // advance all the dates (actually wind them back)
            let dStart = Date.parse(sDate) - 86400 * 1000 * iDays; // add iDays of milliseconds!
            this.$userEngine.setPref(
              `nourish.onboarding.tracks.${sFocus}.${sDateKey}`,
              new Date(dStart).toUTCString()
            );
          }
          // else, ignore the (natural) blanks..
        });
      });
    },

    getOBxTotalDays() {
      let iDays = [
        this.$userEngine.getPref(`nourish.onboarding.tracks.time.start`),
        this.$userEngine.getPref(`nourish.onboarding.tracks.topics.start`),
        this.$userEngine.getPref(`nourish.onboarding.tracks.locales.start`),
      ]
        .filter(Boolean)
        .map((s) => {
          // we could dick around for ages... what time of day when they signed up (for them, locally), what time is it now, how many *real* days is that etc..
          // ... but let's just round for now ... the offset will get swallowed once across the whole detox.  Who cares (ie. - go live! fix later..)
          //  return Math.floor((((new Date()).setHours(5, 0, 0, 0) - Date.parse(s)) / 1000) / 86400);
          return Math.round((Date.now() - Date.parse(s)) / 1000 / 86400);
        })
        .reduce((a, c) => {
          return c > a ? c : a;
        }, 0); // Jimbo's hacky "max()" .. sure there's a better way but I'm rushing
      return iDays;
    },

    getOBxDaysPastStep() {
      let iDays = [
        this.$userEngine.getPref(`nourish.onboarding.tracks.time.start`),
        this.$userEngine.getPref(`nourish.onboarding.tracks.topics.start`),
        this.$userEngine.getPref(`nourish.onboarding.tracks.locales.start`),
      ]
        .filter(Boolean)
        .map((s) => {
          // we could dick around for ages... what time of day when they signed up (for them, locally), what time is it now, how many *real* days is that etc..
          // ... but let's just round for now ... the offset will get swallowed once across the whole detox.  Who cares (ie. - go live! fix later..)
          //  return Math.floor((((new Date()).setHours(5, 0, 0, 0) - Date.parse(s)) / 1000) / 86400);
          return Math.round((Date.now() - Date.parse(s)) / 1000 / 86400);
        })
        .reduce((a, c) => {
          return c < a ? c : a;
        }, 999); // Jimbo's hacky "max()" .. sure there's a better way but I'm rushing
      return iDays;
    },

    getOBxTotalSteps() {
      let iSteps = [
        this.$userEngine.getPref(`nourish.onboarding.tracks.time.start`),
        this.$userEngine.getPref(`nourish.onboarding.tracks.topics.start`),
        this.$userEngine.getPref(`nourish.onboarding.tracks.locales.start`),
      ]
        .filter(Boolean)
        .map((a) => (a ? 1 : 0))
        .reduce((a, v) => a + v, 0);
      return iSteps;
    },

    getOBxDetoxDay() {
      // okay... notjust days,  because they might have skipped.  We stick at the choices!
      let iOBxDay = this.getOBxTotalDays();
      let iSteps = this.getOBxTotalSteps();
      // let iDetoxDay = Math.min(iSteps * 3 + 1, iOBxDay);
      let iDetoxDay = Math.min(iSteps * 3, iOBxDay);
      return iDetoxDay;
    },

    getOBxPickAvailable() {
      // let iDetoxDay = this.getOBxDetoxDay();
      // let iSteps = this.getOBxTotalSteps();
      // // okay.. have they started fewer steps than we'd expect?
      // let iExpected = Math.ceil(iDetoxDay / 3);
      // this.notice(`Expected: ${iExpected} (${iDetoxDay}), Actual: ${iSteps}`);
      // return (iDetoxDay >= 2) && (iSteps < iExpected);

      // changed.. to just look at whether we're 3+ days past the most recent start-step
      //        .. to allow lingerers a clear 3+ days per step.
      // return true;
      // console.log(`------------- `, this.getOBxDaysPastStep(), this.getOBxDetoxDay());
      return (
        this.getOBxDaysPastStep() >= 1 &&
        this.getOBxDetoxDay() <= this.iMaxCoachDays
      );
    },

    getOBxPickContent(iDay = -1) {
      // legacy:
      // let iDay = this.getOBxTotalSteps();

      // now one for each day
      switch (iDay) {
        case 0:
          return {
            title: `Let's go!`,
            body: `You're doing brilliantly. You've unlocked the second ring of your Nourish dial. Let's choose what to focus on next.`,
          };
        case 1:
          return {
            title: `Your dial helps you read the <span class="callout"> right amount</span>`,
            dial: true,
            focus: this.getDialFocus,
            action: "Learn more",
            body: `Understand your dial and how it can help you stay on track during your 7 day news detox.`,
          };
        case 2:
          return {
            title: `Play our unique emoji <span class="callout">quiz</span> game`,
            icon: "newsle-mark",
            confetti: true,
            focus: "newsle",
            action: "Play Newsle",
            body: `A super fun game to test your daily knowledge. Can you match the emojis to a leading story?`,
          };
        case 3:
          return {
            title: `It's time to <span class="callout">unlock</span> the next step!`,
            dial: true,
            focus: this.getDialFocus,
            action: "Unlock",
            body: `Amazing work! You're making great progress through your news detox. Let's take a look unlocking the next ring.`,
          };
        case 4:
          return {
            title: `Unlock channels by <span class="callout">inviting</span> friends`,
            icon: "onboarding-wave",
            action: "Invite friends",
            body: `Get even more news for free just be inviting friends. You'll earn an unlock for every friend that joins!`,
          };
        case 5:
          return {
            title: `What if the news was writen <span class="callout">for you</span>?`,
            icon: "onboarding-find",
            focus: "misc",
            action: "Don't just read, ask",
            body: `Ask Nourish about any story, topic or person and dive into their latest news.`,
          };
        case 6:
          return {
            title: `The <span class="callout">final</span> step of your news detox.`,
            dial: true,
            focus: this.getDialFocus,
            action: "Unlock",
            body: `Astonishing. It's time to take full control. Let's wrap up with a check-in and unlock the final ring.`,
          };
        case 7:
          return {
            title: `<span class="callout">Congratulations!</span> Your detox is complete!`,
            confetti: true,
            focus: "pro",
            action: `What's next?`,
            body: `You made it! You're detox is complete. Learn what's next up for you.`,
          };
        default:
          return false;
        // return {
        //   title: `Oops!`,
        //   // body: ``,
        // };
      }
    },

    getExtraCallOuts() {
      let aCallOuts = [];

      // if there are avaiable unlocks... say so..
      if (!this.isPro && this.getAccount?.system?.unlocks) {
        let iUnlocks = this.getAccount?.system?.unlocks;
        let sUnlocks = this.$options.filters.plural(iUnlocks, "unlock");
        aCallOuts.push({
          name: `${iUnlocks} ${sUnlocks} available`,
          type: "more-unlock",
          section: "more-nourish",
          class: "playlist-shimmer nbgx",
        });
      }

      if (this.isAlpha) {
        // aCallOuts.push({
        //   type: "callout",
        //   section: "more-nourish",
        // });
      }

      // if (!this.isPro) {
      //   aCallOuts.push({
      //     name: "How to unlock more content…",
      //     slug: "unlock?intro=true",
      //     type: "more-how-unlock",
      //     section: "more-nourish",
      //     class: aCallOuts.length ? "" : "nbgx",
      //   });
      // }

      if (!aCallOuts.length) {
        return [];
      }

      return [
        {
          name: "Getting the most from Nourish",
          slug: "more-nourish",
          features: aCallOuts,
        },
      ];

      // unused at the moment..

      // {
      //   name: '3 more countries to go!',
      //   slug: 'dashboard',
      //   type: 'more-dashboard',
      //   section: 'more-nourish'
      // },
    },

    debug() {},

    notice() {
      // console.log(`\x1b[33mCoachingEngine --`, ...arguments);
    },

    error() {
      console.log(`\x1b[33mCoachingEngine --`, ...arguments);
    },

    /**
     *  Legacy -- never used in anger -- tabBarCoaching thing..
     */

    fireTabCoaching(oPrefs) {
      let oMerge = {
        ...{
          tab: `dashboard`,
          content: {
            dial: false, //or// `content`, // - Default is false, to show large dial above, set to `full`. To show dial smaller and left of content, set to `content`
            heading: ``, // - Don`t include to hide heading.
            text: ``, // - Don`t include to hide paragraph.
            cta: {
              text: ``, // - Button text. Don`t include to hide button.
              action: {
                type: `close`, // - No action needed if it`s just to close, will close by default, otherwise pass `route` to navigate to another route and close coaching.
                route: ``, // - Set type to `route` and pass the route you want it to go.
              },
            },
            cancel: true,
          },
        },
        ...oPrefs,
      };
      console.log(oMerge);
      this.EventBus.$emit("coaching:show", oMerge);
    },
  }, // end methods

  created() {
    this.notice("Up and running... ");
    // JASON -- UNCOMMENT THIS TO DEBUG!
    // window.setTimeout(() => {
    //   this.fireTabCoaching({
    //     tab: `home`,
    //     content: {
    //       image: `swipe-skip-trans`,
    //       heading: `Swipe to Skip`,
    //       text: `Swipe stories that don't matter.<br/>Reach newsfeed-zero every day.`,
    //       ghost: `Awesome! I'll try that.`,
    //     },
    //   });
    // }, 1000);
  },

  watch: {
    // $route(to, from) {
    //   //
    // },
    // foo(to) {
    //   this.bar();
    // },
    // prefs: {
    //   deep: true,
    //   handler: function(to, from) {
    //   }
    // }
  },
});

Object.defineProperties(Vue.prototype, {
  $coachingEngine: {
    get: function () {
      return coachingEngine;
    },
  },
});
